import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { Popover } from '../../../../../global/popover/popover';
import { ArtifactPopoverPresentation } from './artifact-popover.presentation';
import { artifactTypeLabel } from '../../../../../../constants/artifacts.constants';
import { ArtifactType, IArtifactDTO } from '../../../../../../api/artifacts.dao';
import DefaultButton from '../../../../../global/default-button/default-button';

import './artifact-popover.scss';

interface IProps {
    artifact: IArtifactDTO;
    deleteArtifactPermission: boolean;
    onDeleteArtifact: (assetMetadataId: number, meetingId: number, assetType: ArtifactType) => void;
    onPreviewArtifact: () => void;
    meetingId: number;
}

const ArtifactPopover = (props: IProps) => {
    const {
        artifact,
        deleteArtifactPermission,
        onDeleteArtifact,
        meetingId,
        onPreviewArtifact,
    } = props;

    const { assetType } = artifact;
    const [isViewsOpen, setIsViewsOpen] = useState<boolean>(false);

    const viewsRef = useRef(null);

    return (
        <div
            className='artifact-popover-container'
            ref={viewsRef}
        >
            <DefaultButton
                text={artifactTypeLabel[assetType]}
                className={classnames('artifact-popover-container__asset-type', {
                    'active': isViewsOpen
                })}
                modifier='row'
                onClick={() => setIsViewsOpen(true)}
                withEllipsis
            />
            <Popover
                isOpen={isViewsOpen}
                buttonRef={viewsRef}
                withCloseIcon
                onClose={() => setIsViewsOpen(false)}
                onClickOutside={() => setIsViewsOpen(false)}
                customWidth={170}
                padding={0}
                position='top'
                align='start'
            >
                <ArtifactPopoverPresentation
                    artifact={artifact}
                    deleteArtifactPermission={deleteArtifactPermission}
                    onDeleteArtifact={onDeleteArtifact}
                    onPreviewArtifact={onPreviewArtifact}
                    meetingId={meetingId}
                />
            </Popover>
        </div>
    );
};


export { ArtifactPopover };
